import axios from 'axios'
import swal from 'sweetalert2'
// import Auth from 'helpers/Auth'
import * as Sentry from '@sentry/react'
import uuid from 'uuid'
import { GetExternalUrlsFromDomain } from 'polaris-adventures-js'

/**
 *
 * @param {Object} options
 * @param {String} options.uri
 * @param {Number} options.timeout
 * @param {Object} options.headers
 * @param {Boolean} options.noHeaders
 */
function xhrFactory(options = { uri: null, timeout: null, headers: null, noHeaders: false }) {
  const headers = options.headers || {}

  const xhr = axios.create({
    baseURL:
      (options && options.uri) ||
      GetExternalUrlsFromDomain('WaiverWeb', window.location.origin, process.env.REACT_APP_LOCAL_DEV_BACKEND).BackendApi,
    timeout: options && options.timeout !== null ? options.timeout : 30000,
    headers
  })

  xhr.interceptors.request.use(async (config) => {
    if (!options.noHeaders) {
      config.headers['cache-control'] = 'no-cache'
    }
    config.headers['ext-msg-id'] = uuid.v4()

    Sentry.addBreadcrumb({
      category: 'axios',
      message: `${config.method} ${config.url}`,
      level: 'info'
    })

    return config
  })

  xhr.interceptors.response.use(
    function (res) {
      // console.log(res)
      return res
    },
    function (error) {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            swal.fire({
              title: 'Session Expired',
              text: 'Your session has expired. you are being redirected to the login page.',
              icon: 'warning',
              // @ts-ignore
              button: 'OK'
            })
            return Promise.reject(error)
          case 403:
            swal.fire({
              title: 'Session Expired',
              text: 'Sorry, you are unauthorized to perform that task.',
              icon: 'warning',
              // @ts-ignore
              button: 'OK'
            })
            return Promise.reject(error)
          case 404:
            swal.fire('Not Found', 'This is not the page you are looking for.', 'warning')
            return Promise.reject(error)
          case 422:
          case 500:
          case 502:
          default:
            swal.fire({
              title: 'Sorry, an unexpected error occurred. If this problem persists, please contact support.',
              text: error.response.data.message,
              icon: 'warning',
              // @ts-ignore
              button: 'OK'
            })
            Sentry.withScope((scope) => {
              scope.setFingerprint([`Received ${error.request.status} on ${error.request.responseURL}`])
              scope.setTag('ext-msg-id', error.config.headers['ext-msg-id'])
              Sentry.captureException(error)
            })
            return Promise.reject(error)
        }
      }
      return Promise.reject(error)
    }
  )

  return xhr
}

export default xhrFactory
